import React, { useState, useEffect } from 'react'

import clsx from 'clsx'

import Button from 'components/Button'
import Icon from 'components/Icon'
import Typography from 'components/Typography'
import { useAppContext } from 'context/AppContext'
import useViewport from 'hooks/useViewport'

import classes from './StickyFilterToggle.module.scss'

const noop = () => {}

const icon = selectedFilters =>
  selectedFilters ? (
    <div className={classes.selectedFilters}>
      <span> {selectedFilters < 10 ? selectedFilters : '9+'}</span>
    </div>
  ) : (
    <Icon icon={['fal', 'sliders-h']} className={classes.icon} size="16" />
  )

const displayedLabel = (selectedFilters, label) => {
  if (selectedFilters == 1) return label.toLowerCase().slice(0, -1)
  if (selectedFilters > 1) return label.toLowerCase()
  return label
}

/** @type {import("./types").default} */
export const StickyFilterToggle = ({ label = 'Filters', onClick = noop, selectedFilters }) => {
  const [isStickyFilterButtonSticking, setIsStickyFilterButtonSticking] = useState(false)
  const { isCypressTakingSnapshots } = useAppContext()
  const { up } = useViewport()

  const handleClick = event => {
    onClick(event)
  }

  useEffect(() => {
    const stickyFilterButton = document.querySelector('.StickyFilterToggle')
    if (!stickyFilterButton || up('md') || isCypressTakingSnapshots) return

    const stickyContainer = document.querySelector('.StickyContainer')
    const updateStickingIfIntersecting = ([e]) => setIsStickyFilterButtonSticking(e.isIntersecting)
    const intersectionOptions = {
      root: stickyContainer,
      rootMargin: '-50px 0px 0px 0px',
    }

    const observer = new IntersectionObserver(updateStickingIfIntersecting, intersectionOptions)
    observer.observe(stickyFilterButton)
    return () => observer.disconnect()
  }, [isCypressTakingSnapshots, up])

  return (
    <Button
      className={clsx('StickyFilterToggle', classes.stickyFilterToggleButton, {
        [classes.withSelectedFilters]: selectedFilters,
        [classes.sticking]: isStickyFilterButtonSticking,
      })}
      onClick={handleClick}
      variant="contained"
    >
      {icon(selectedFilters)}
      <Typography variant="body-xs">{displayedLabel(selectedFilters, label)}</Typography>
    </Button>
  )
}

export default StickyFilterToggle
